webpackJsonp([14],{

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_remain_vue__ = __webpack_require__(1192);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fed04c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_remain_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fed04c6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_remain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fed04c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_remain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: "https://centralize.maeriminterfood.com",
  baseURLV2: "https://marim-mis-api.maeriminterfood.com"
  // baseURLV2: 'https://marim-api-test.undefined.co.th:4439'
  // baseURLV2: "http://localhost:6100"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  addSale: function addSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateSale: function UpdateSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdBill: function holdBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openShift: function openShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShift: function closeShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/close', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShiftDetail: function getHostShiftDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/details', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billList: function billList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBill: function printBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printHolding: function printHolding(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBillCredit: function printBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPaybill: function printPaybill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSaleOnHost: function getSaleOnHost(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/cancel', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHoldingBill: function getHoldingBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/bill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReportBill: function getReportBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ExportMoney: function ExportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/expense/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  PrintCloseShif: function PrintCloseShif(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openCashBox: function openCashBox(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveList: function receiveList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveCancel: function receiveCancel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveById: function receiveById(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditList: function billCreditList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveNew: function receiveNew(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveUpdate: function receiveUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptSearch: function receiptSearch(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDetail: function receiptDetail(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDel: function receiptDel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  payBillCredit: function payBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPayBillCredit: function printPayBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosByDoc: function getPosByDoc(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosList: function getPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/return/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditDetail: function billCreditDetail(URL, header, body, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/print/data', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/print/data', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billReceiptDetail: function billReceiptDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipExpend: function slipExpend(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/expense/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipIncome: function slipIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/income/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkReturn: function checkReturn(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/check/return', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listAll: function listAll(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/list/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeCus: function removeCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/remove/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  AddCus: function AddCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/add/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateCus: function UpdateCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/update/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1104);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  updateSale: function updateSale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/updatesalesdetails', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  branch: function branch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/branch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteHoldBil: function deleteHoldBil(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/deleteHoldbill', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUser: function roleUser(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUser', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserDelete: function roleUserDelete(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserDelete', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGetCode: function roleUserGetCode(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGetCode', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGet: function roleUserGet(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGet', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserUpdate: function roleUserUpdate(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserUpdate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserInsert: function roleUserInsert(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserInsert', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getRemainStock: function getRemainStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/getRemainStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeStock: function changeStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/changeStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getItemGroup: function getItemGroup(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/dashboard/getItemGroup', null).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_pos__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service_undefined__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_service_customer__ = __webpack_require__(1109);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report_data: [],
      startDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      data_edit: {},
      data_edit_pay: {},
      endDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      branch: 0,
      branchName: "",
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      modal_title: "",
      modal_active: false,
      item_amount: 0.00,
      item_unit: 0.00,
      item_sum: 0.00
    };
  },

  computed: {
    item_amounts: {
      get: function get() {
        if (this.item_amount !== '') return parseFloat(this.item_amount).toFixed(2);else return parseFloat(0).toFixed(2);
      },
      set: function set(newValue) {
        this.item_amount = newValue;
      }
    },
    item_units: {
      get: function get() {
        if (this.item_unit !== '') return parseFloat(this.item_unit).toFixed(2);else return parseFloat(0).toFixed(2);
      },
      set: function set(newValue) {
        this.item_unit = newValue;
      }
    }
  },
  methods: {
    onSelectBranch: function onSelectBranch(val) {
      this.dyn_address = val.dyn_address;
      this.getCus();
    },
    onUnitSelect: function onUnitSelect(val) {},
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    editHoldBild: function editHoldBild(e, d) {
      this.data_edit = e;
      this.item_amount = e.price;
      this.item_unit = e.qty;
      this.item_sum = parseFloat(this.item_amount) * parseFloat(this.item_unit);
      this.data_edit_pay = d;
    },
    saveHoldBild: function saveHoldBild(e) {},
    onPriceChange: function onPriceChange() {
      // this.data_edit.sub = this.data_edit.amount-this.data_edit.amount;
      // this.data_edit.amount =
      //   parseFloat(this.data_edit.price) * parseFloat(this.data_edit.qty);
      this.item_sum = parseFloat(this.item_amount) * parseFloat(this.item_unit);
      // this.item_unit = this.item_unit.toFixed(2);

      // this.data_edit.sub += this.data_edit.amount;
    },
    NumbersOnly: function NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      this.report_data = [];
      this.form_data = "";
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        // begin_date: '2020-08-01',
        // end_date: '2020-09-01',
        company_id: 1,
        branch_id: 1,
        // begin_code: '0236',
        // end_code: '0236',
        begin_code: this.begin_code,
        end_code: this.end_code,
        keyword: ""
      };
      this.$store.state.isLoading = false;
      this.$store.commit("Loading");
      __WEBPACK_IMPORTED_MODULE_3__services_service_report__["a" /* default */].holdingByPaybill(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.state.isLoading = false;
        // this.$store.commit("Loading");
        if (result.response === "success") {
          _this.report_data = result.data;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.report_data);
        } else {
          _this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
        }
      }, function (error) {
        _this.$store.commit("Loading");
        _this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", error.message);
        _this.$store.state.isLoading = false;
      });
    },
    printAllHoldPDF: function printAllHoldPDF(obj) {
      var _this2 = this;

      // console.log(obj)
      if (obj.length > 0) {

        this.$store.commit("Loading");
        __WEBPACK_IMPORTED_MODULE_5__services_service_undefined__["a" /* default */].branch({
          branchName: this.branch.branch_name
        }, this.header, function (results) {
          if (results.data.success.length > 0) {
            obj[0]["bank_account"] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + results.data.success[0].def_account_code;
            // this.$store.commit("Loading");
            // console.log(obj)
            _this2.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
            setTimeout(function () {
              _this2.$refs.printHoldingAll.submit();
              _this2.$store.commit("Loading");
            }, 1000);
          }
        }, function (errors) {
          _this2.$store.commit("Loading");
          _this2.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        });

        // this.$store.commit("Loading");
        // this.form_data = JSON.stringify(obj);
        // setTimeout(() => {
        //   this.$refs.printHoldingAll.submit();
        //   this.$store.commit("Loading");
        // }, 1000);
      }
    },
    printHoldingPDF: function printHoldingPDF(obj) {
      var _this3 = this;

      // console.log(this.branch.branch_name);
      obj["branch_name"] = this.report_data[0].branch_name;
      obj["branch_address"] = this.report_data[0].branch_address;
      obj["branch_telephone"] = this.report_data[0].branch_telephone;
      obj["company_name"] = this.report_data[0].company_name;
      obj["tax_id"] = this.report_data[0].tax_id;
      __WEBPACK_IMPORTED_MODULE_5__services_service_undefined__["a" /* default */].branch({
        branchName: this.branch.branch_name
      }, this.header, function (results) {
        if (results.data.success.length > 0) {
          obj["bank_account"] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + results.data.success[0].def_account_code;
          _this3.$store.commit("Loading");
          console.log(obj);
          _this3.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
          setTimeout(function () {
            _this3.$refs.printHolding.submit();
            _this3.$store.commit("Loading");
          }, 1000);
        }
      }, function (errors) {
        _this3.$store.commit("Loading");
        _this3.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
      });
    },
    save_modal: function save_modal() {
      var _this4 = this;

      this.data_edit.price = parseFloat(this.item_amount).toFixed(2);
      this.data_edit.qty = parseFloat(this.item_unit).toFixed(2);
      this.data_edit.amount = parseFloat(this.item_sum).toFixed(2);
      console.log(this.data_edit.amount);
      // this.data_edit.amount =
      //   parseFloat(this.data_edit.price) * parseFloat(this.data_edit.qty);

      __WEBPACK_IMPORTED_MODULE_5__services_service_undefined__["a" /* default */].updateSale({
        branchName: this.branch.branch_name,
        data: this.data_edit
      }, this.header, function (result) {
        _this4.modal_active = false;
        _this4.alert_msg("success", "บันทึกข้อมูลสำเร็จ", result.message);
      }, function (error) {
        _this4.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
      });
    },
    close_modal: function close_modal() {
      this.modal_active = false;
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format("HH:mm:ss");
    },
    editVendor: function editVendor(data) {
      this.modal_title = "แก้ไขข้อมูลใบพักบิล : ";

      $("#modal_active").modal("show");
      // this.modal_data = data
    },
    getHost: function getHost() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_service_pos__["a" /* default */].getHostShift(sessionStorage.Url, this.header, function (result) {
        if (result.response === "success") {
          _this5.host_list = result.data;
          _this5.host = _this5.host_list[0];
          // this.getReport()
        } else {
          _this5.alert_msg("warning", "ดึงข้อมูลจุดขายไม่ได้", result.message);
        }
      }, function (error) {
        _this5.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
      });
    },
    calQTY: function calQTY(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["qty"];
      });
      return total;
    },
    calAmount: function calAmount(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["amount"];
      });
      return total;
    },
    calAmountBranch: function calAmountBranch(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["total_amount"];
      });
      return total;
    },
    calAmountBranchAll: function calAmountBranchAll(obj) {
      var total = 0;
      // obj.forEach(v => {
      //   v.forEach(val => {
      //     total += val['total_amount']
      //   })
      // })
      return total;
    },
    capEnter: function capEnter() {
      $("a").on("keyup", function (e) {
        if (e.which == 13) {
          console.log(e.target.href);
        }
      });
    },
    getCus: function getCus() {
      var _this6 = this;

      this.$store.state.isLoading = true;
      var body = {
        keyword: "",
        limit: 100000,
        status: 1
      };
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].callMisApi(this.dyn_address + "/" + "customer/v1/list/customer", {
        headers: {
          "Access-Token": this.branch.access_token
        }
      }, body, function (result) {
        if (result.response === "success") {
          _this6.data_cus_list = result.data;
        } else {
          _this6.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
        }
        _this6.$store.state.isLoading = false;
      }, function (error) {
        _this6.alert_msg("warning", "ดึงข้อมูลลูกหนี้", error.message);
        _this6.$store.state.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.checkUser();
    this.getHost();
    this.getBranch();
    setTimeout(function () {
      _this7.branch = _this7.$store.state.branch_list[0];
      _this7.dyn_address = _this7.$store.state.branch_list[0].dyn_address;
      _this7.getCus();
    }, 500);
  }
});

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("5748e936", content, true, {});

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-fed04c6a]{background-color:#ffffad}.head-branch[data-v-fed04c6a]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-fed04c6a]{color:#000;background-color:#ffffad;border-color:#ffffad}.table .thead-footer th[data-v-fed04c6a]{color:#000;text-align:center;background-color:#ffff}#sendMoney .table tr[data-v-fed04c6a],.table td[data-v-fed04c6a],.table th[data-v-fed04c6a]{padding:0;vertical-align:top;border-top:0 solid #dee2e6}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/report_holding_remain.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACpB,eAAkB,CACnB,AACD,uCACE,WAAe,AACf,yBAA0B,AAC1B,oBAAsB,CACvB,AACD,yCACE,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CACzB,AACD,4FAGE,UAAW,AACX,mBAAoB,AACpB,0BAA8B,CAC/B","file":"report_holding_remain.vue","sourcesContent":["\n.head_table[data-v-fed04c6a] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-fed04c6a] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n.table .thead-dark th[data-v-fed04c6a] {\n  color: #000000;\n  background-color: #ffffad;\n  border-color: #ffffad;\n}\n.table .thead-footer th[data-v-fed04c6a] {\n  color: #000000;\n  text-align: center;\n  background-color: #ffff;\n}\n#sendMoney .table tr[data-v-fed04c6a],\n.table td[data-v-fed04c6a],\n.table th[data-v-fed04c6a] {\n  padding: 0;\n  vertical-align: top;\n  border-top: 0px solid #dee2e6;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-4 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("ลูกค้าเริ่ม")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},attrs:{"show-search":"","option-filter-prop":"children","filter-option":_vm.filterOption},model:{value:(_vm.begin_code),callback:function ($$v) {_vm.begin_code=$$v},expression:"begin_code"}},[_c('a-select-option',{attrs:{"value":""}},[_vm._v("\n                -- ไม่เลือก --\n              ")]),_vm._v(" "),_vm._l((_vm.data_cus_list),function(b,i){return _c('a-select-option',{key:'branch' + i,attrs:{"value":b.code}},[_vm._v("\n                "+_vm._s(b.code)+"/"+_vm._s(b.name)+"\n              ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-4 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("ลูกค้าสุดท้าย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},attrs:{"show-search":"","option-filter-prop":"children","filter-option":_vm.filterOption},model:{value:(_vm.end_code),callback:function ($$v) {_vm.end_code=$$v},expression:"end_code"}},[_c('a-select-option',{attrs:{"value":""}},[_vm._v("\n                -- ไม่เลือก --\n              ")]),_vm._v(" "),_vm._l((_vm.data_cus_list),function(b,i){return _c('a-select-option',{key:'branch' + i,attrs:{"value":b.code}},[_vm._v("\n                "+_vm._s(b.code)+"/"+_vm._s(b.name)+"\n              ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-4 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.onSelectBranch(_vm.branch)}]}},_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-4 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-4 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_holding_cus_remain.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_holding_cus_remain.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.printAllHoldPDF(_vm.report_data)}}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" ใบวางบิลทั้งหมด\n            ")])])]),_vm._v(" "),(_vm.report_data.length < 1)?_c('div',{staticClass:"text-center pt-3"},[_c('h5',[_vm._v("ไม่มีข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.report_data),function(c,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(c.pay_bill.length > 0),expression:"c.pay_bill.length > 0"}],key:'c' + i,staticClass:"table-responsive-sm mt-3"},[_c('h4',{staticClass:"m-1 p-1"},[_vm._v("สาขา: "+_vm._s(c.branch_name || "-"))]),_vm._v(" "),_vm._l((c.pay_bill),function(cus_d,i){return _c('div',{key:'cus_d' + i,staticClass:"table table-bordered",attrs:{"id":"sendMoney"}},[_c('table',{staticClass:"table table-bordered",attrs:{"id":"sendMoney","colspan":"6"}},[_c('tr',{staticStyle:{"background":"#ffc10782"}},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                ลูกค้า: "+_vm._s(cus_d.ar_code)+"/"+_vm._s(cus_d.ar_name)+"\n              ")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("เบอร์: "+_vm._s(cus_d.ar_telephone))]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_c('div',{staticClass:"d-flex justify-content-between",staticStyle:{"margin":"0.25rem 0.25rem 0.25rem"}},[_c('div',[_vm._v("\n                    มูลค่ารวม: "+_vm._s(_vm.numberFormatDecimal(cus_d.total_amount))+"\n                  ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-primary btn-block p-0",staticStyle:{"font-size":"0.875rem","padding":"0 0.25rem 0 0.25rem !important"},attrs:{"type":"submit"},on:{"click":function($event){return _vm.printHoldingPDF(cus_d)}}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" ใบวางบิล\n                    ")])])])])]),_vm._v(" "),_vm._l((cus_d.invoice),function(d,i){return _c('tbody',{key:'d' + i},[_c('tr',{staticStyle:{"background":"#fffed4"}},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("เลขที่ใบพักบิล: "+_vm._s(d.doc_no))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                  วันที่: "+_vm._s(_vm.dateFormatAndTime(d.doc_date))+"\n                ")]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("\n                  ส่วนลด: "+_vm._s(_vm.numberFormatDecimal(d.discount_amount))+"\n                ")])]),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_vm._l((d.sub),function(s,i){return _c('tr',{key:'csub' + i},[_c('td',[_vm._v(_vm._s(s.item_barcode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(s.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(s.price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(s.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.numberFormatDecimal(s.price * s.qty))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"padding":"0 0.25rem","margin":"0.25rem"},attrs:{"type":"button"},on:{"click":function($event){_vm.modal_active = true;
                      _vm.modal_title = "แก้ไขข้อมูลใบพักบิล : " + (d.doc_no) + " ";
                      _vm.editHoldBild(s, d);}}},[_c('i',{staticClass:"fas fa-edit"})])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Remark: "+_vm._s(d.description || "-"))]),_vm._v(" "),_c('td',{staticStyle:{"background":"#ebf6ff"}},[_vm._v("\n                  รวมพักบิล: "+_vm._s(d.doc_no)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.numberFormatDecimal(_vm.calQTY(d.sub)))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"background":"#ffd5d4"}},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"background":"#e2ffd4"}},[_vm._v("\n                  "+_vm._s(_vm.numberFormatDecimal(_vm.calAmount(d.sub)))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"background":"#e2ffd4"}})])],2)})],2)])})],2)}),_vm._v(" "),(_vm.calAmountBranchAll(_vm.report_data) > 0)?_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"pt-2 pl-2 pb-0",staticStyle:{"background":"#eeffeb","text-align":"left"}},[_c('h5',[_vm._v("\n              รวมทุกสาขา:\n              "+_vm._s(_vm.numberFormatDecimal(_vm.calAmountBranchAll(_vm.report_data)))+" บาท\n            ")])])])]):_vm._e(),_vm._v(" "),_c('a-modal',{attrs:{"title":_vm.modal_title,"centered":""},on:{"ok":_vm.save_modal,"cancel":_vm.close_modal},model:{value:(_vm.modal_active),callback:function ($$v) {_vm.modal_active=$$v},expression:"modal_active"}},[_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_edit.item_barcode),expression:"data_edit.item_barcode"}],staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"บาร์โค้ด...."},domProps:{"value":(_vm.data_edit.item_barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_edit, "item_barcode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_edit.item_name),expression:"data_edit.item_name"}],staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"รายละเอียด...."},domProps:{"value":(_vm.data_edit.item_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_edit, "item_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"salePrice"}},[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.item_amounts),expression:"item_amounts",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"salePrice","maxlength":"8","placeholder":"ราคาขาย...."},domProps:{"value":(_vm.item_amounts)},on:{"keypress":_vm.NumbersOnly,"change":function($event){return _vm.onPriceChange()},"input":function($event){if($event.target.composing){ return; }_vm.item_amounts=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"saleUnit"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.item_units),expression:"item_units",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"saleUnit","maxlength":"8","placeholder":"จำนวน...."},domProps:{"value":(_vm.item_units)},on:{"keypress":_vm.NumbersOnly,"change":function($event){return _vm.onPriceChange()},"input":function($event){if($event.target.composing){ return; }_vm.item_units=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"ส่วนลด....","value":"0.00"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true"},domProps:{"value":_vm.numberFormatDecimal(_vm.item_amount * _vm.item_unit)}})])])]),_vm._v(" "),_c('form',{ref:"printHolding",attrs:{"action":"/static/pdf/report_sale_holdbill.php","target":"_blank","method":"POST"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}})]),_vm._v(" "),_c('form',{ref:"printHoldingAll",attrs:{"action":"/static/pdf/report_sale_holdbill_all.php","target":"_blank","method":"POST"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}})])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit"}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"text-center",staticStyle:{"background":"#ebf6ff"}},[_c('th',[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',[_vm._v("รายละอียด")]),_vm._v(" "),_c('th',[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('th',[_vm._v("จำนวน")]),_vm._v(" "),_c('th',[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',[_vm._v("รวม")]),_vm._v(" "),_c('th',[_vm._v("แก้ไข")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.ac50fcd5e4af8250092d.js